import { ConstantNeedModel, NumericRange } from 'rlv-common';
import { NavigationAction } from '../../../routing/StateMachineTypes';
import { TrackingElement } from '../../../tracking/tracking.types';
import { TemplateLayout } from '../../../types/FormTemplate.types';
import { constantSumInsuredValidator } from '../../../validation/ConstantNeedBlock';
import { NeedSubPageProps } from '../Needs.types';
import {
  CONSTANT_SLIDER_FORM_TEMPLATES_LAYOUT,
  ComponentFieldNames,
  SliderFormValues,
} from '../NeedsPageContainer.data';
import { SliderForm, SliderFormProps } from '../forms/SliderForm/SliderForm';

export const ConstantSumInsuredPage = ({
  valueRanges,
  storeState,
  handleAction,
  tracker,
}: NeedSubPageProps) => {
  const constantSumInsured: TemplateLayout<NumericRange> =
    CONSTANT_SLIDER_FORM_TEMPLATES_LAYOUT.sumInsured;

  const SETUP = {
    componentFieldName: ComponentFieldNames.SumInsured,
    sliderConfig: {
      min: valueRanges.insuranceSum.min,
      max: valueRanges.insuranceSum.max,
      step: SliderFormValues.DefaultInsuranceSumInterval,
      text: '€',
      trackerUpdate: (value: number) =>
        tracker.updateTariffOptions({
          VersSum: value,
        }),
    },
    templateLayout: {
      ...constantSumInsured,
      footerInfoSection: () =>
        constantSumInsured.footerInfoSection &&
        constantSumInsured.footerInfoSection(valueRanges.insuranceSum),
      clickTracking: (value: TrackingElement) => tracker.trackClickEvent({ clickedElement: value }),
    },
    formValues: {
      sumInsured: storeState.sumInsured || valueRanges.insuranceSum.defaultValue,
    },
    validationSchema: constantSumInsuredValidator(valueRanges),
    onHandleSliderFormActions: (
      { sumInsured }: { sumInsured: number },
      navigationAction: NavigationAction,
    ) => {
      if (navigationAction === NavigationAction.NEXT) {
        storeState.update({ sumInsured });
      }

      handleAction(navigationAction);
    },
    handleNavigateNoSubmitAction: () => {
      handleAction(NavigationAction.BACK);
    },
  };

  return <SliderForm<ConstantNeedModel> {...(SETUP as SliderFormProps<ConstantNeedModel>)} />;
};
